<template>
	<!-- To be filled by specific implementations -->
</template>

<script>
import { DebounceTimer } from "@/common/utils/debounce";

export default {
	props: {
		searchAllow: { type: Boolean, default: false }, // Adds a search option as first entry
		searchCustom: { type: Boolean, default: false }, // Overrides default search logic. Options must be filtered on your own
		searchDebounce: { type: Number, default: 0 }, // Delay for search requests in ms while user is typing
		searchMinLength: { type: Number, default: 0 }, // Minimum amount of characters required to search
		options: { type: Array, default: null }, // Array of search options
		optionsValueField: { type: String, default: null }, // Field of the options object to be used as internal value. Whole object is used if this is null
		optionsValueGetter: { type: Function, default: null }, // Getter function to assemble the options value
		optionsKeyField: { type: String, default: null }, // Field of the options object to be used as internal key. If not specified options value is used
		optionsKeyGetter: { type: Function, default: null }, // Getter function to assemble the options key
		optionsDisplayField: { type: String, default: null },  // Field of the options object to be used as display value. Whole object is used if this is null
		optionsDisplayGetter: { type: Function, default: null }, // Getter function to assemble the options display value
		noEntriesText: { type: String, default: "" }, // Custom text to show in case the options list is empty
		noSearchResultsText: { type: String, default: "" }, // Custom text to show in case no search results are found
		disabled: { type: Boolean, default: false },
		required: { type: Boolean, default: false }
	},
	data() {
		return {
			searchValue: ""
		};
	},
	computed: {
		searchResults() {
			if (!this.options) {
				return [];
			}

			return this.searchCustom
				? this.options
				: this.options.filter(item => this.getOptionDisplayValue(item)
					.toLowerCase()
					.includes(this.searchValue.toLowerCase()));
		},
		emptyText() {
			if (this.searchValue) {
				return this.noSearchResultsText || this.$t("common.select.noSearchResults");
			} else {
				return this.noEntriesText || this.$t("common.select.noEntries");
			}
		}
	},
	methods: {
		search(value) {
			DebounceTimer.debounce("search", () => {
				if (this.searchMinLength === 0 || (value && value.length > this.searchMinLength)) {
					this.searchValue = value;
					this.$emit("search", this.searchValue);
				}
			}, this.searchDebounce, this);
		},
		resetSearch() {
			this.searchValue = "";
		},
		getOptionValue(option) {
			if (this.optionsValueGetter) {
				return this.optionsValueGetter(option);
			} else {
				return this.optionsValueField ? this.resolveOptionFieldPath(this.optionsValueField, option) : option;
			}
		},
		getOptionKey(option) {
			if (!this.optionsKeyGetter && !this.optionsKeyField) {
				return this.getOptionValue(option);
			}

			if (this.optionsKeyGetter) {
				return this.optionsKeyGetter(option);
			} else {
				return this.optionsKeyField ? this.resolveOptionFieldPath(this.optionsKeyField, option) : option;
			}
		},
		getOptionDisplayValue(option) {
			if (this.optionsDisplayGetter) {
				return String(this.optionsDisplayGetter(option));
			} else {
				return String(this.optionsDisplayField ? this.resolveOptionFieldPath(this.optionsDisplayField, option) : option);
			}
		},
		resolveOptionFieldPath(path, option) {
			return path.split('.').reduce((prev, curr) => {
				return prev ? prev[curr] : undefined;
			}, option);
		}
	}
};
</script>